import * as React from 'react';
import {
  List,
  DatagridConfigurable,
  TextField,
  EditButton,
  NumberInput,
  SelectColumnsButton,
  TopToolbar,
  FilterButton,
  CreateButton,
  DateInput, DateField,
  useLocaleState, NumberField, FunctionField, ImageField
} from "react-admin";
import { truncate } from "../helper/truncate";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const filters = [
    <NumberInput key={0} source="id" label="id" min={1} />,
    <DateInput key={6} source="createdAt#$gte" label="Start Created At" />,
    <DateInput key={7} source="createdAt#$lte" label="End Created At" />,
];

export const LifestyleList = () => {
  const [locale] = useLocaleState();

  return (
    <List
      filters={filters}
      sort={{ field: 'id', order: 'DESC' }}
      actions={<ListActions />}
    >
      <DatagridConfigurable rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" />
        <ImageField source="file.path" label={'Image'} />
        <TextField source={`title.${locale}`} />
        <TextField source={`slug.${locale}`} />
        <FunctionField
          label={'Summary'}
          render={(record: any) => truncate(record.summary[locale], 100)}
        />

        <DateField source="publishedAt" showTime locales="lv-LV" />
        <DateField source="createdAt" showTime locales="lv-LV" />
        <EditButton />
      </DatagridConfigurable>
    </List>
  )
};
